import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    const projectPage = document.querySelector('.single-projecten')
    if (projectPage !== null) {

        const modalSlider = new Splide('.js-image-modal-slider', {
            type: 'fade',
            pagination: false,
            drag: false,
            fixedHeight: "90rem",
            height: "90rem",
            fixedWidth: "100%",
        })

        const mainHeroSlide = new Splide('.js-image-slider', {
            type: 'loop',
            pagination: false,
            drag: false,
            gap: "2rem",
            fixedHeight: "58rem",
            breakpoints: {
                1023: {
                    gap: '1rem',
                    height: "30rem",
                    fixedHeight: "30rem",
                },
            },
        })

        mainHeroSlide.sync(modalSlider)
        mainHeroSlide.mount()
        modalSlider.mount()

        const zoomableImages = document.querySelectorAll('.js-zoom-image')
        const zoomModal = document.querySelector('.js-gallery-modal')

        zoomableImages.forEach(function (img) {
            img.addEventListener('click', function () {
                if (window.innerWidth >= 1023) {
                    const imgId = img.getAttribute('data-id')

                    const zoomImg = document.querySelector('.js-zoomed-image.is-active')
                    zoomImg.classList.remove('is-active')
                    zoomImg.classList.remove('is-visible')

                    const targetImage = document.querySelector('.js-zoomed-image[data-id="' + imgId + '"]')
                    targetImage.classList.add('is-active')
                    targetImage.classList.add('is-visible')

                    toggleModal(zoomModal)
                }
            })
        })

        function toggleModal(modal) {
            if (modal.classList.contains('is-active')) {
                modal.classList.remove('is-active')
                document.body.classList.remove('no-scroll')
                document.documentElement.classList.remove('no-scroll')
            }

            if (!modal.classList.contains('is-active')) {
                modal.classList.add('is-active')
                document.body.classList.add('no-scroll')
                document.documentElement.classList.add('no-scroll')
            }
        }

        document.querySelector('.js-zoom-modal-close').addEventListener('click', function(e) {
            zoomModal.classList.remove('is-active')
            document.body.classList.remove('no-scroll')
            document.documentElement.classList.remove('no-scroll')
        })

    }
})
